import Vue from 'vue'
import VueRouter from 'vue-router'
 import Login from '@/components/Login_dev_env.vue'
//import Login from '@/components/Login.vue'
import smartChat from '@/views/smartChat.vue' // 引入刚才新建的组件
/* Layout */
import Layout from '@/layout'

Vue.use(VueRouter)

// --- 【新增代码】开始 ---
// 解决 Vue-Router 3.x 版本在路由重定向时控制台报 Uncaught (in promise) 错误的问题
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
// --- 【新增代码】结束 ---

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/smart-chat',
    name: 'smartChat',
    component: smartChat,
    meta: { title: '智能问答' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录页' }
  }
]

const createRouter = () => new VueRouter({
  mode: 'hash',
  routes: constantRoutes
})

const router = createRouter()

// 重置路由方法
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router